import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthConfig, tokenNotExpired } from 'angular2-jwt';

import { NoAuthApi } from './api.service';
import { Token } from '../entities/index';
import { Log } from '../utils/index';


@Injectable()
export class AuthService {
  constructor(protected http: NoAuthApi, protected authConfig: AuthConfig) {}

  @Log('green')
  login(email: string, password: string): Observable<Token> {
    return this.http.post('/user/login', {username: email, password: password});
  }

  @Log('green')
  authenticate(token: Token) {
    localStorage.setItem(this.authConfig.getConfig().tokenName, token.access_token);

    // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript/38552302#38552302
    const access_token = token.access_token;
    const base64Url = access_token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decodedToken = JSON.parse(window.atob(base64));

    localStorage.setItem('userid', decodedToken.identity);
  }

  loggedIn() {
    return tokenNotExpired();
  }

  @Log('green')
  logout() {
    localStorage.removeItem(this.authConfig.getConfig().tokenName);
    localStorage.removeItem('userid');
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/auth.service.ts